import type { Unit, UnitPhone } from "../s3";

export const CHANNEL_UNITS_SOURCE_ID = "channel-units";

export function isChannelUnitsSource(
  contentTypeId: string | null | undefined,
): boolean {
  return contentTypeId === CHANNEL_UNITS_SOURCE_ID;
}

/**
 * Telefone principal da unidade: o primeiro da lista ordenada por `order`.
 * A projeção reduzida do `metadata.json` já traz `phoneNumber` pronto; a
 * completa do `channel.json` só traz a árvore de telefones.
 */
export function resolveMainPhoneNumber(unit: {
  phoneNumber?: string | null;
  phones?: UnitPhone[] | null;
}): string | null {
  if (unit?.phoneNumber) return unit.phoneNumber;

  const sortedPhones: UnitPhone[] = Array.isArray(unit?.phones)
    ? [...unit.phones].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    : [];

  return sortedPhones[0]?.phoneNumber ?? null;
}

export function normalizeUnits(units: Unit[]): Array<Record<string, unknown>> {
  return (units || []).map((unit) => {
    if (unit?.phoneNumber) {
      return unit as unknown as Record<string, unknown>;
    }

    return {
      ...unit,
      phoneNumber: resolveMainPhoneNumber(unit),
    };
  });
}
